// extracted by mini-css-extract-plugin
module.exports = {"checkList":"RegisterForm_checkList__ELXGt"};